import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ForgotPasswordService {
  constructor(private readonly http: HttpClient) {}

  forgotPassword(payload: any): Observable<any> {
    let url = `${environment.API_URL}/v1/oauth/generate-reset-otp?envType=${environment.envType}`

    return this.http.post(url, payload);
  }
  changePassword(payload: any): Observable<any> {
    let url = `${environment.API_URL}/v1/oauth/reset-password?envType=${environment.envType}`

    return this.http.post(url, payload);
  }
}
